var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandCategories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#expand-categories_svg__clip0_61530_7465)",
    fill: "#45464F"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5 19.5H15V21h4.5v-1.5zM21 13.5h-6V15h6v-1.5zM22.5 7.5H15V9h7.5V7.5zM12.75 3h-1.5v18h1.5V3zM7.94 2.97L5.25 5.437 2.559 2.969 1.5 4.03 5.25 7.5 9 4.03 7.94 2.97z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "expand-categories_svg__clip0_61530_7465"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
}
export default SvgExpandCategories;